<script setup lang="ts">
import AdvancedSettingsEditor from '~components/admin/AdvancedSettingsEditor.vue'

defineProps<{
  initialSettings: Array<{
    key: string
    group: string
    type: string
    value: unknown
    nullable: boolean
  }>
}>()
</script>

<template>
  <b-container fluid>
    <h1>Advanced Settings</h1>
    <hr>
    <AdvancedSettingsEditor :initial-settings="initialSettings" />
  </b-container>
</template>
